<template>
    <v-card style="border-radius: 1em;" class="pa-2">
        <v-card-text>
            <h1 class="mb-3" style="text-align: center;">Detalhes do Voucher</h1>
            <v-layout justify-end>
                <v-btn small round  :color="ativo ? 'success': 'error' ">{{ativo ? 'Ativo': 'Desativo'}}</v-btn>
            </v-layout>
            <v-layout row wrap style="font-size: 1.3em;">
                <v-flex xs6 v-if="voucher.compra.posto">
                    Vendedor: <b>{{voucher.compra.posto ? voucher.compra.posto.nome_fantasia : 'Não informado'}}</b>
                </v-flex>
                <v-flex xs6>
                    Comprador: <b>{{
                        voucher.usuario_beneficiado && voucher.usuario_beneficiado.pessoa ? `${voucher.usuario_beneficiado.pessoa.nome} ${voucher.usuario_beneficiado.pessoa.sobrenome}`
                        : voucher.empresa_beneficiada ? voucher.empresa_beneficiada.nome_fantasia : 'Não informado'
                        }}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra && voucher.compra.posto">
                    CNPJ do Estabelecimento: <b>{{voucher.compra.posto.cnpj}}</b>
                </v-flex>
                <v-flex xs6>
                    {{voucher.usuario_beneficiado ? 'CPF' : 'CNPJ'}} do Cliente:
                    <b>{{voucher.usuario_beneficiado && voucher.usuario_beneficiado.pessoa ? voucher.usuario_beneficiado.pessoa.cpf : voucher.empresa_beneficiada ? voucher.empresa_beneficiada.cnpj : 'Não Informado'}}</b>
                </v-flex>
                <v-flex xs6>
                    Data da Compra: <b>{{voucher.compra && voucher.compra.data_compra ? voucher.compra.data_compra.split('-').reverse().join('/') : 'Não Informada'}}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra && voucher.compra.tipo_pagamento">
                    Tipo de pagamento: <b>{{voucher.compra.tipo_pagamento}}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra && voucher.compra.nsu">
                    NSU: <b>{{voucher.compra.nsu}}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra">
                    Foi Pago: <b>{{voucher.compra.confirmado ?  'SIM' : 'NÃO'}}</b>
                </v-flex>
                <v-flex xs6>
                    Valor da Compra: <b v-if="voucher.compra && voucher.compra.valor_total">{{voucher.compra.valor_total | currency({ fractionCount: 2 })}}</b>
                    <b v-else>Não Consta</b>
                </v-flex>
                <v-flex xs6>
                    Valor da Pago: <b v-if="voucher.compra && voucher.compra.valor">{{voucher.compra.valor | currency({ fractionCount: 2 })}}</b>
                    <b v-else>Não Consta</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra">
                    ID Compra: <b>{{voucher.compra.id_compra}}</b>
                </v-flex>
                <v-flex xs6>
                    Pago em: <b>{{voucher.compra.metodo_pagamento === 'pospago' ? 'Estabelecimento' : 'Aplicativo' }}</b>
                </v-flex>
                <v-flex xs6>
                    Nome de Estabelecimento: <b v-if="voucher.compra && voucher.compra.posto">{{voucher.compra.posto.nome_fantasia }}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra.metodo_pagamento === 'pospago'">
                    Endereço de Estabelecimento: <b>{{
                        voucher.compra.posto && voucher.compra.posto.endereco ?
                        `${voucher.compra.posto.endereco.logradouro}, Nº${voucher.compra.posto.endereco.numero} - ${voucher.compra.posto.endereco.bairro}. ${voucher.compra.posto.endereco.cidade}/${voucher.compra.posto.endereco.estado}. CEP: ${voucher.compra.posto.endereco.cep}`:
                        'Não informado'
                    }}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.usuario_beneficiado">
                    Endereço do cliente: <b>{{
                        voucher.usuario_beneficiado && voucher.usuario_beneficiado.pessoa && voucher.usuario_beneficiado.pessoa.endereco ? `${voucher.usuario_beneficiado.pessoa.endereco.logradouro}, Nº${voucher.usuario_beneficiado.pessoa.endereco.numero} - ${voucher.usuario_beneficiado.pessoa.endereco.bairro}. ${voucher.usuario_beneficiado.pessoa.endereco.cidade}/${voucher.usuario_beneficiado.pessoa.endereco.estado}. CEP: ${voucher.usuario_beneficiado.pessoa.endereco.cep}`: 'Não informado'
                    }}</b>
                </v-flex>
                <v-flex xs6>
                    Produto adiquirido: <b>{{voucher.compra.combustivel ? "Combustível": '' }}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.compra.combustivel">
                    Tipo de combustível: <b>{{voucher.compra.combustivel ? voucher.compra.combustivel.nome: '' }}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher">
                    Foi Abastecido: <b>{{!voucher.disponivel ? 'SIM' : 'NÃO' }}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.disponivel && voucher.data_inativado">
                    Data de Abastecimento: <b>{{voucher.data_inativado.split('-').reverse().join('/')}}</b>
                </v-flex>
                <v-flex xs6 v-if="voucher.disponivel && voucher.hora_inativado">
                    Horário de Abastecimento: <b>{{voucher.hora_inativado ? voucher.hora_inativado : "Não possui"}}</b>
                </v-flex>
                <v-flex xs12 v-if="voucher.veiculo">
                    Placa do Veículo Usado: {{voucher.veiculo.identificacao}}
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn block @click="$emit('fechar')">Fechar</v-btn>
            <v-btn block :color="ativo ? 'error': 'success'" @click="desativarVoucher">{{ ativo ? 'Cancelar Voucher' : 'Reativar Voucher'}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['voucher'],
    methods: {
        formatarCor (cor) {
            if (cor === null) return ''
            if (cor === undefined) return ''
            if (cor.length === 6) return `#${cor}`
            if (cor.length === 7) return cor
            if (cor.length === 9) return cor.slice(0, 7)
            else {
                let teste = parseInt(cor)
                teste = teste.toString(16)
                return `#${teste.slice(2, 8)}`
            }
        },
        desativarVoucher () {
            if (!this.cancelada) {
                this.$store.dispatch('desativarVoucher', this.voucher.id_voucher).then(() => {
                    this.ativo = !this.ativo
                    this.$emit('carregarVouchers')
                })
            }
        }
    },
    data: () => ({
        ativo: false
    }),
    beforeMount () {
        if (this.voucher) {
            this.ativo = this.voucher.ativo
        }
    }
}
</script>
